import React from "react";
import { Editor } from "slate";
import { Plugin } from "slate-react";
import { BLOCKS } from "../html";
import { AddHotkey } from "./hotkey";
import { AddIsToggledQuery } from "./isToggled";
import { AddToggleCommand } from "./toggleCommand";

const headingPlugin = (type: string, key: string, tag: string): Plugin[] => {

  const isHeading = (editor: Editor) => editor.value.blocks.some(block => block.type === type);

  const toggleHeading = (editor: Editor): Editor => {
    const newBlockType = isHeading(editor) ? BLOCKS.PARAGRAPH.type : type;
    editor.setBlocks(newBlockType);
    return editor;
  };

  return [
    AddIsToggledQuery(type, isHeading),
    AddToggleCommand(type, toggleHeading),
    AddHotkey({ key, action: toggleHeading }),
    {
      renderBlock: (props, controller, next) => {
        const { attributes, children, node } = props;
        if (node.type === type) {
          const Heading = tag as any; // Ignore type error - this works
          return (
            <Heading {...attributes} className={node.data.get("className")}>
              {children}
            </Heading>
          );
        }
        else {
          return next();
        }
      },
    },
  ];
};

/**
 * Slate plugin to handle h1 blocks
 */
export const Heading1 = headingPlugin(BLOCKS.HEADING1.type, "1", BLOCKS.HEADING1.tags[0]);

/**
 * Slate plugin to handle h2 blocks
 */
export const Heading2 = headingPlugin(BLOCKS.HEADING2.type, "2", BLOCKS.HEADING2.tags[0]);

/**
 * Slate plugin to handle h3 blocks
 */
export const Heading3 = headingPlugin(BLOCKS.HEADING3.type, "3", BLOCKS.HEADING3.tags[0]);
